
import { PropType, defineComponent } from 'vue'

import DropDownComponent from './../form/DropDownComponent.vue'

export interface PlanAffiliationNetworkOption {
  title: string
  value: string
  isSelected?: boolean
}

export interface PlanAffiliationPlan {
  planId: string
  clientId?: string
  networkAffiliation?: {
    uuid?: string
    networkName?: string
    clientName?: string
  }
  networkAffiliationOptions?: PlanAffiliationNetworkOption[]
}

export interface PlanAffiliationClientOption {
  title: string
  value?: string
  plans?: PlanAffiliationPlan[] | null
  disabled?: boolean
  isSelected?: boolean
}

export interface PlanAffiliationDomain {
  value: string
  title: string
  plans: PlanAffiliationPlan[] | null
  planType: '' | 'Javelina' | 'HRP'
}

export interface PlanAffiliationFormState {
  current: PlanAffiliationDomain
  configured: PlanAffiliationDomain
  clientOptions: PlanAffiliationClientOption[]
  jvPlansGroupedByClientId: Record<string, PlanAffiliationPlan[]>
  hrpPlansGroupedByClientId: Record<string, PlanAffiliationPlan[]>
  reloadKey: number
  enabledTab: boolean
}

export default defineComponent({
  name: 'plan-affiliations-form',
  components: {
    DropDownComponent
  },
  props: {
    planAffiliation: {
      type: Object as PropType<PlanAffiliationFormState>,
      required: true
    }
  }
})
